document.addEventListener("DOMContentLoaded", function () {
  const videoButton = document.querySelector(".yt_icon-parent");
  const antiTheftIframe = document.querySelector("#anti-theft-iframe");
  const overlay = document.querySelector(".overlay");
  videoButton.addEventListener("click", handleVideoButtonClick);

  antiTheftIframe.addEventListener("load", function () {
    overlay.remove();
    videoButton.remove();
  });

  function handleVideoButtonClick(e) {
    e.preventDefault();
    antiTheftIframe.src = antiTheftIframe.dataset.src;
  }
});
